import { createContext } from "react";

export const RegisterContext = createContext({
  isRegistered: false,
  userId: null,
  register: () => {},
  unregister: () => {}
});